import {inject, Injectable, signal} from '@angular/core';
import {LocalStorageService} from './storage.service';
import {ApiProgService} from '@kilobytelab/domain';
import {SemanaProyecto} from '@kilobytelab/types';
import {DateTime} from 'luxon';
import {AppService} from './app.service';

@Injectable({
  providedIn: 'root'
})
export class ProgramacionService {

  private appService = inject(AppService);
  private localstorage = inject(LocalStorageService);
  private apiProg = inject(ApiProgService);

  PROYECTOS = signal<{tipo: string, proyecto: SemanaProyecto}[]>([]);

  async checkProgramacion() {
    const appInfo = this.appService.APP();
    const alumnos = this.appService.PADRE();
    if (!appInfo?.programacion || !alumnos?.length) {
      this.PROYECTOS.set([]);
      await this.localstorage.setProyectos([]);
      return
    }
    const tiposUnicos = new Set(
      this.appService.PADRE()
        .filter(a => a.aula !== 0 && a.tipo !== '')
        .map(a => a.tipo)
    );
    const tipos = Array.from(tiposUnicos);
    if (!tipos.length) {
      this.PROYECTOS.set([]);
      await this.localstorage.setProyectos([]);
      return
    }
    try {
      const date: string = DateTime.now().toSQLDate();
      const peticiones = tipos.map(async (tipo) => {
        const proyecto: SemanaProyecto = await this.apiProg.getProgramacionByDate(tipo, date);
        return {tipo, proyecto}
      });
      const proyectos = await Promise.all(peticiones);
      this.PROYECTOS.set(proyectos);
      await this.localstorage.setProyectos(this.PROYECTOS())
    } catch (err) {
      const guardados: {tipo: string, proyecto: SemanaProyecto}[] = await this.localstorage.getProyectos();
      if (!guardados) {
        throw new Error('Error recuperando la programación')
      }
      this.PROYECTOS.set(guardados)
    }
  }

}